import { useMemo } from 'react'
import { useTranslate } from 'react-polyglot'
import { tokens } from '@getgo/chameleon-core/next/goto-admin'
import { Autocomplete, CircularProgress, Option, Typography } from '@getgo/chameleon-web-react-wrapper'
import { makeStyles } from '@material-ui/core'

import { usePbxSwitcher } from 'hooks'

const useStyles = makeStyles(() => ({
  autocompleteLabel: {
    ['&::part(label)']: {
      marginBottom: 0,
    },
  },
}))

const PbxSwitcher = () => {
  const t = useTranslate()
  const classes = useStyles()

  const { autocompleteRef, loading, options, scroll, selectedOption, handlerOnChange, handlerOnInput, handlerOnClear } =
    usePbxSwitcher()

  const PBXSwitcherLoader = useMemo(
    () => (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute',
          height: '100%',
          width: '100%',
          top: scroll,
          backgroundColor: tokens.surfaceColorDefaultSemitransparent,
        }}
      >
        <CircularProgress />
      </div>
    ),
    [scroll],
  )

  return (
    <Autocomplete
      ref={autocompleteRef}
      label=""
      placeholder={t('Search PBXs')}
      disableFiltering
      onInput={handlerOnInput}
      onClearClick={handlerOnClear}
      onChange={handlerOnChange}
      data-testid="searchPBXsAutocomplete"
      className={classes.autocompleteLabel}
    >
      {options.map((pbx) => (
        <Option
          value={pbx.lmiAccountKey}
          key={pbx.lmiAccountKey}
          style={{ padding: `${tokens.spacing02}` }}
          selected={pbx.lmiAccountKey === selectedOption}
          label={pbx.name}
        >
          <>
            <Typography noWrap>{pbx.name}</Typography>
            <Typography noWrap variant="caption-small">{`(${pbx.domain})`}</Typography>
          </>
        </Option>
      ))}
      {loading && PBXSwitcherLoader}
    </Autocomplete>
  )
}

export default PbxSwitcher
